export const TAG_GROUP_DETAIL_CREATE_ACTION = "TAG_GROUP_DETAIL_CREATE_ACTION";
export const TAG_GROUP_DETAIL_LIST_ACTION = "TAG_GROUP_DETAIL_LIST_ACTION";
export const TAG_GROUP_DETAIL_LIST_SUCCESS = "TAG_GROUP_DETAIL_LIST_SUCCESS";
export const TAG_GROUP_DETAIL_GET_UPDATE_ACTION = "TAG_GROUP_DETAIL_GET_UPDATE_ACTION";
export const TAG_GROUP_DETAIL_GET_UPDATE_SUCCESS = "TAG_GROUP_DETAIL_GET_UPDATE_SUCCESS";
export const TAG_GROUP_DETAIL_DELETE_ACTION = "TAG_GROUP_DETAIL_DELETE_ACTION";
export const TAG_GROUP_DETAIL_UPDATE_ACTION = "TAG_GROUP_DETAIL_UPDATE_ACTION";

export const TAG_GROUP_DETAIL_GET_ALL_ACTION = "TAG_GROUP_DETAIL_GET_ALL_ACTION";
export const TAG_GROUP_DETAIL_GET_ALL_SUCCESS = "TAG_GROUP_DETAIL_GET_ALL_SUCCESS";

export const TAG_GROUP_GET_ALL_ACTION = "TAG_GROUP_GET_ALL_ACTION";
export const TAG_GROUP_GET_ALL_SUCCESS = "TAG_GROUP_GET_ALL_SUCCESS";

export const TAG_GROUP_GET_ALL_SKU_ACTION = "TAG_GROUP_GET_ALL_SKU_ACTION";
export const TAG_GROUP_GET_ALL_SKU_SUCCESS = "TAG_GROUP_GET_ALL_SKU_SUCCESS";

export const TAG_GROUP_DETAIL_MAP_SKU_ACTION = "TAG_GROUP_DETAIL_MAP_SKU_ACTION";
export const TAG_GROUP_DETAIL_MAP_SKU_SUCCESS = "TAG_GROUP_DETAIL_MAP_SKU_SUCCESS";

export const TAG_GROUP_DETAIL_CREATE_TRANSLATE_ACTION = "TAG_GROUP_DETAIL_CREATE_TRANSLATE_ACTION";
export const TAG_GROUP_DETAIL_CREATE_TRANSLATE_SUCCESS = "TAG_GROUP_DETAIL_CREATE_TRANSLATE_SUCCESS";
export const TAG_GROUP_DETAIL_UPDATE_TRANSLATE_ACTION = "TAG_GROUP_DETAIL_UPDATE_TRANSLATE_ACTION";
export const TAG_GROUP_DETAIL_UPDATE_TRANSLATE_SUCCESS = "TAG_GROUP_DETAIL_UPDATE_TRANSLATE_SUCCESS";
export const TAG_GROUP_DETAIL_DELETE_TRANSLATE_ACTION = "TAG_GROUP_DETAIL_DELETE_TRANSLATE_ACTION";
export const TAG_GROUP_DETAIL_DELETE_TRANSLATE_SUCCESS = "TAG_GROUP_DETAIL_DELETE_TRANSLATE_SUCCESS";

export const TAG_GROUP_DETAIL_FAIL = "TAG_GROUP_DETAIL_FAIL";
export const TAG_GROUP_FAIL = "TAG_GROUP_FAIL";
export const TAG_FAIL = "TAG_FAIL";

export const GET_TAG_IN_TAGGROUP_ACTION = "GET_TAG_IN_TAGGROUP_ACTION";
export const GET_TAG_IN_TAGGROUP_SUCCESS = "GET_TAG_IN_TAGGROUP_SUCCESS";

export const GET_TAG_BY_SKU_ACTION = "GET_TAG_BY_SKU_ACTION";
export const GET_TAG_BY_SKU_SUCCESS = "GET_TAG_BY_SKU_SUCCESS";

export const TAG_GROUP_SKU_MAPPING_UPDATE_ACTION = "TAG_GROUP_SKU_MAPPING_UPDATE_ACTION";
export const TAG_GROUP_SKU_MAPPING_UPDATE_SUCCESS = "TAG_GROUP_SKU_MAPPING_UPDATE_SUCCESS";

export const TAG_GROUP_GET_BY_TAG_GROUP_ACTION = "TAG_GROUP_GET_BY_TAG_GROUP_ACTION";
export const TAG_GROUP_GET_BY_TAG_GROUP_SUCCESS = "TAG_GROUP_GET_BY_TAG_GROUP_SUCCESS";